import React from 'react';
import PropTypes from 'prop-types';

import config from '../../config';

// Secondary wordmark color is the same across every category variant.
const SECONDARY_COLOR = '#939598';

// Primary (accent) color tracks the same CSS custom property the rest of
// the marketplace uses for category theming (set per store type in
// PageBuilder/ListingPageFullImage/AuthenticationPage), so the logo always
// matches the current category's brand color without needing its own map.
const accentColor = 'var(--marketplaceInitialDefaultColor)';

// Single shared logo mark (BuySell "vintage" wordmark).
const LogoMark = props => {
  const { className, label, ...rest } = props;
  return (
    <svg
      width="126"
      height="54"
      viewBox="0 0 126 54"
      fill="none"
      className={className}
      role="img"
      aria-label={label}
      {...rest}
    >
      {label ? <title>{label}</title> : null}
      <g>
        <g>
          <path
            style={{ fill: accentColor }}
            d="M12.55,10.86h6.54c.81,0,1.57.1,2.27.29.7.2,1.3.48,1.81.86.5.38.9.87,1.2,1.46.29.59.44,1.29.44,2.09,0,1.08-.3,1.96-.9,2.64-.6.68-1.38,1.18-2.34,1.5v.05c.57.04,1.1.18,1.59.44.5.26.93.59,1.29,1.01.36.42.65.9.86,1.45.21.55.32,1.14.32,1.78,0,.85-.17,1.6-.52,2.25-.35.65-.82,1.19-1.42,1.63-.6.44-1.3.78-2.1,1.01-.8.23-1.66.35-2.58.35h-6.46V10.86ZM15.1,18.67h3.48c.48,0,.93-.05,1.35-.15.43-.1.8-.26,1.12-.49s.57-.52.76-.88.28-.79.28-1.3c0-.74-.24-1.39-.72-1.94-.48-.55-1.23-.82-2.26-.82h-4.01v5.58ZM15.1,27.44h3.75c.39,0,.82-.04,1.29-.12.47-.08.91-.24,1.32-.48s.75-.56,1.04-.97c.28-.41.42-.95.42-1.62,0-1.12-.36-1.95-1.09-2.51-.73-.56-1.71-.84-2.95-.84h-3.77v6.54Z"
          />
          <path
            style={{ fill: accentColor }}
            d="M30.45,10.86v11.53c0,.58.08,1.19.24,1.82.16.63.43,1.21.8,1.74.37.53.86.97,1.46,1.3.6.34,1.35.5,2.23.5s1.63-.17,2.23-.5c.6-.34,1.09-.77,1.46-1.3.37-.53.64-1.11.8-1.74.16-.63.24-1.24.24-1.82v-11.53h2.55v11.93c0,1.1-.19,2.09-.56,2.99-.37.89-.89,1.67-1.54,2.33s-1.43,1.16-2.31,1.51c-.89.35-1.84.53-2.87.53s-1.98-.18-2.87-.53c-.89-.35-1.66-.86-2.31-1.51-.66-.66-1.17-1.43-1.54-2.33-.37-.89-.56-1.89-.56-2.99v-11.93h2.55Z"
          />
          <path
            style={{ fill: accentColor }}
            d="M50.35,21.65l-7.12-10.79h3.27l5.13,8.26,5.29-8.26h3.11l-7.12,10.79v8.02h-2.55v-8.02Z"
          />
        </g>
        <g>
          <path
            fill={SECONDARY_COLOR}
            d="M69.86,15.46c-.34-.43-.79-.74-1.37-.94-.58-.2-1.12-.31-1.63-.31-.3,0-.61.04-.93.11-.32.07-.62.18-.9.33-.28.15-.51.35-.69.6-.18.25-.27.55-.27.9,0,.57.21,1,.64,1.3.42.3.96.56,1.61.77.65.21,1.34.43,2.09.64.74.21,1.44.51,2.09.9.65.39,1.18.91,1.61,1.57.42.66.64,1.53.64,2.63s-.2,1.96-.58,2.74c-.39.78-.92,1.43-1.58,1.94-.66.51-1.43.89-2.31,1.14-.88.25-1.8.37-2.78.37-1.22,0-2.36-.19-3.4-.56-1.05-.37-2.02-.97-2.92-1.81l2.95-3.24c.42.57.96,1.01,1.61,1.32.65.31,1.32.46,2.01.46.34,0,.68-.04,1.02-.12.35-.08.66-.2.93-.36.27-.16.5-.36.66-.61.17-.25.25-.54.25-.88,0-.57-.22-1.01-.65-1.34-.43-.33-.98-.61-1.63-.84-.66-.23-1.36-.46-2.13-.69-.76-.23-1.47-.54-2.13-.93-.66-.39-1.2-.9-1.63-1.54s-.65-1.48-.65-2.52.2-1.89.6-2.66c.4-.76.93-1.4,1.59-1.91.66-.51,1.43-.9,2.3-1.16.87-.26,1.76-.39,2.68-.39,1.06,0,2.09.15,3.08.45.99.3,1.89.81,2.68,1.51l-2.84,3.11Z"
          />
          <path
            fill={SECONDARY_COLOR}
            d="M74.93,10.86h12.78v3.83h-8.63v3.51h8.16v3.83h-8.16v3.83h9.11v3.83h-13.26V10.86Z"
          />
          <path fill={SECONDARY_COLOR} d="M90.63,10.86h4.14v14.98h7.68v3.83h-11.82V10.86Z" />
          <path fill={SECONDARY_COLOR} d="M103.86,10.86h4.14v14.98h7.68v3.83h-11.82V10.86Z" />
        </g>
      </g>
      <g>
        <path
          style={{ fill: accentColor }}
          d="M32.52,36.79h-1.07c-.54.64-1.24,1.67-2.1,3.11l-1.03,1.73-3.27-4.85h-1.03v-.27h4.29v.27h-1.03s1.91,2.76,1.91,2.76c.63-.96.95-1.88.96-2.76h-.82v-.27h3.17v.27Z"
        />
        <path
          style={{ fill: accentColor }}
          d="M40.36,41.36h-4.62v-.27h1.28v-4.3h-1.28v-.27h3.85v.27h-.54v4.3h1.31v.27ZM38.91,32.1c-.42.9-.63,2.01-.63,3.33v.34h-.4v-.34c0-1.34-.2-2.45-.61-3.33h1.63Z"
        />
        <path
          style={{ fill: accentColor }}
          d="M53.15,41.36h-3.34v-3.91c0-.5-.15-.75-.44-.75-.72,0-1.4.54-2.05,1.63v2.75h1.31v.27h-4.62v-.27h1.28v-4.3h-1.28v-.27h3.31v1.16c.7-.86,1.49-1.29,2.36-1.29.65,0,1.18.19,1.59.58.4.38.61.88.61,1.5v2.64h1.28v.27Z"
        />
        <path
          style={{ fill: accentColor }}
          d="M61.83,40.75c-.62.5-1.32.75-2.1.75s-1.31-.15-1.62-.44c-.2-.19-.3-.6-.3-1.22v-3.04h-1.33v-.27h1.33v-4.98h2.03v4.98h1.98v.97h-.37c-.26-.46-.8-.7-1.61-.7v3.16c0,.53,0,.77,0,.71.03.34.18.51.46.51.37,0,.81-.19,1.32-.58l.21.15Z"
        />
        <path
          style={{ fill: accentColor }}
          d="M73.75,40.65c-.59.57-1.3.85-2.12.85-.87,0-1.43-.29-1.68-.87-.75.58-1.54.87-2.38.87-.64,0-1.15-.14-1.54-.41-.39-.27-.58-.63-.58-1.09,0-.59.32-1.1.97-1.52.65-.43,1.43-.64,2.34-.64.36,0,.74.05,1.14.15v-1.26c-.22-.06-.41-.08-.58-.08-1.32,0-2.25.33-2.78,1h-.28l.09-.92c.89-.24,1.79-.36,2.71-.36,1.43,0,2.33.31,2.68.93.12.22.19.57.19,1.07v1.87c0,.57.12.85.37.85.31,0,.7-.2,1.17-.61l.28.15ZM69.9,40.2v-1.93c-.4-.1-.81-.15-1.21-.15-.47,0-.75.09-.86.26-.11.17-.16.62-.16,1.35,0,.65,0,.92-.02.8.05.42.2.63.47.63s.58-.1.93-.29c.36-.19.65-.42.86-.67Z"
        />
        <path
          style={{ fill: accentColor }}
          d="M85.94,36.79h-1.24v4.13c.03.24.16.4.4.48-.51,1.59-1.89,2.38-4.13,2.38-.47,0-1.13-.06-1.98-.19-.53-.08-.95-.12-1.26-.12v-1.12h.16c.78.77,1.9,1.16,3.36,1.16.65,0,1.07-.13,1.26-.38.09-.12.14-.51.14-1.15v-1.16c-.62.36-1.35.54-2.17.54-.9,0-1.64-.23-2.21-.69-.57-.46-.85-1.05-.85-1.78s.29-1.33.88-1.8c.58-.48,1.33-.71,2.23-.71.84,0,1.55.23,2.12.7v-.56h3.29v.27ZM82.64,40.39v-2.7c-.36-.69-1.05-1.04-2.08-1.04-.45,0-.74.26-.86.77-.03.17-.05.55-.05,1.13,0,1.24.04,1.97.13,2.2.09.23.36.34.83.34.84,0,1.52-.23,2.03-.7Z"
        />
        <path
          style={{ fill: accentColor }}
          d="M96.86,40.56c-1.03.62-2.13.94-3.31.94-1.04,0-1.91-.24-2.59-.71-.69-.48-1.03-1.08-1.03-1.8s.35-1.34,1.05-1.84c.7-.5,1.56-.76,2.57-.76.95,0,1.7.2,2.24.59.54.4.83.95.86,1.65h-4.46c-.02.21-.02.46-.02.77,0,.73.09,1.22.28,1.46.19.25.57.37,1.14.37,1.21,0,2.23-.42,3.06-1.28h.21v.61ZM95.41,38.11c0-.97-.54-1.46-1.62-1.46-.55,0-.94.1-1.17.31-.24.2-.38.57-.42,1.09l-.02.31h3.22c.01-.08.02-.16.02-.24Z"
        />
      </g>
    </svg>
  );
};

const Logo = props => {
  const {
    className,
    format,
    activeCategory,
    CategorySelected,
    isLanding,
    alt,
    title,
    ...rest
  } = props;

  const label = alt || title || config.siteTitle;

  // Every format (desktop/mobile/footer) now shares the same vintage
  // wordmark used in the topbar, so the footer logo always matches it.
  return <LogoMark className={className} label={label} {...rest} />;
};

const { oneOf, string } = PropTypes;

Logo.defaultProps = {
  className: null,
  format: 'desktop',
  activeCategory: null,
  CategorySelected: null,
};

Logo.propTypes = {
  className: string,
  format: oneOf(['desktop', 'mobile', 'footer']),
  activeCategory: string,
  CategorySelected: string,
};

export default Logo;
